const company = {
	/* -------------------------------------------------------------------------- */
	/*                              COMPANY INFO PAGE                             */
	/* -------------------------------------------------------------------------- */
	details: {
		/* ----------------------------- BILLING SECTION ---------------------------- */
		billing: {
			description: "In deze sectie bevinden zich uw facturatiegegevens.",
			status: {
				success: "Uw facturatiegegevens zijn nu succesvol bijgewerkt!",
			},
			title: "Facturatiegegevens",
		},

		/* -------------------------- COMMUNICATION SECTION ------------------------- */
		communication: {
			description: "In deze sectie kunt u uw communicatie voorkeuren aangeven.",
			general: {
				error: "Voeg minimaal één e-mailadres toe aan de algemene mailing list.",
				title: "Mailing list algemene zaken",
			},
			invoice: {
				error: "Voeg minimaal één e-mailadres toe aan de offertes mailing list.",
				title: "Mailing list offertes",
			},
			language: {
				messages: {
					success: "Communicatie voorkeur succesvol gewijzigd!",
				},
				tip: "Dit is de taal waarin mailtjes, facturen en offertes verstuurd zullen worden.",
				title: "Communicatie taal",
			},
			pbs: {
				messages: {
					success: "E-mailadres voor PBS foutmeldingen succesvol bijgewerkt.",
				},
				placeholder: "Bijvoorbeeld foutmeldingen@example.nl",
				title: "E-mailadres voor PBS foutmeldingen",
			},
			status: {
				mailing_list: {
					duplicate: "Het door uw ingevoerde e-mailadres komt al voor in deze lijst.",
					success: "Uw mailing list is succesvol bijgewerkt!",
				},
			},
			title: "Communicatie voorkeuren",
		},
		/* ----------------------------- COMPANY SECTION ---------------------------- */
		company: {
			description: "In deze sectie bevindt zich informatie van uw bedrijf.",
			success: "Gegevens zijn succesvol gewijzigd!",
			title: "Bedrijfs informatie",
		},

		/* ------------------------- CONTACT DETAILS SECTION ------------------------ */
		contact_details: {
			description:
				"Selecteer hier de persoon die verantwoordelijk is voor de bestellingen en het algemene aanspreekpunt is voor Tuxis. ",
			emergency: {
				title: "Noodnummer",
			},
			messages: {
				success: "Het algemene contactpersoon is succesvol bijgewerkt!",
			},
			title: "Algemeen Contactpersoon",
		},
		direct_debit: {
			account_holder: {
				label: "Naam rekeninghouder",
				placeholder: "Bijvoorbeeld Jan Janssen",
			},
			account_number: {
				invalid_iban: "Dit IBAN nummer lijkt niet te kloppen",
				label: "Rekeningnummer (IBAN)",
				placeholder: "Bijvoorbeeld NL00 BANK 0012 3456 78",
			},
			bank_location: {
				label: "Locatie bank",
				placeholder: "Bijvoorbeeld Amsterdam",
			},
			bank_name: {
				label: "Naam bank",
				placeholder: "Bijvoorbeeld ING bank",
			},
			bic_code: {
				label: "BIC-code",
				placeholder: "Bijvoorbeeld INGBNL2A",
			},
			is_active: {
				checkbox_text: "Automatisch incasso inschakelen",
				label: "Automatisch incasso",
			},
			messages: {
				success: "Automatisch incasso gegevens succesvol gewijzigd!",
			},
		},
	},
	tabs: {
		company_details: "Bedrijfsgegevens",
		invoices: "Facturen",
		orders: "Orders",
		user_management: "Gebruikersbeheer",
	},
	title: "Uw bedrijf",
};

export default company;
